<template>
  <div>
    <iframe
      src="https://bead-stone-39a.notion.site/ebd/eff3d33d1275467686f25325d18c812e"
      width="100%"
      height="900"
      frameborder="0"
      allowfullscreen
    />
  </div>
</template>

<script>
export default {
  name: 'Helpdesk'
}
</script>
